export const environment = {
    production: false,
    env_name: 'dev',
    node_api_base_url: 'https://system-apac-west.bizdata360.com',
    streaming_logs_base_url: "wss://api-system-apac-west.bizdata360.com/streaminglogs",
    conversational_ai_base_url: 'wss://m2dl-apac-west.bizdata360.com/hybridsearch/ws',
    // goldfinch_base_url: 'https://pluto.bizdata360.com',
    goldfinch_base_url: 'https://m2dl-apac-west.bizdata360.com',
    download_path: 'https://system-apac-west.bizdata360.com/download',
    python_api_base_url: 'https://api-system-apac-west.bizdata360.com',
    python_websocket_source_base_url: 'wss://api-system-apac-west.bizdata360.com',
    app_base_url: "https://system-apac-west.bizdata360.com",
    stripe_public_key: 'pk_test_51MloEeLdu2fTMait1aNwE8Yyi1NyvF116RbxJAE8D7kLBF7oGh2EkSAFttC5xz0Z9X7ZDHjglOli2ZaKCyQQB3cE004vLCGX6M',
    visit_page: "https://help.bizdata360.com/books/ezintegrations/chapter/accounting-billing",
    mail_to: "support@bizdata360.com",
    STRIPE_DIVIDEBY100: 100,
    secretKey:'1v5cV-kce0tE-dV6wQc5yX9_J5m8OH1vYw5Fz74PA9A=',
    msal_clientId : "b2fd4ab3-145a-47bb-8d19-c15252f71e2d",
    msal_talentId : "4967f11e-370c-45dd-b669-58328a27787b",
    msal_redirectUri : "https://system-apac-west.bizdata360.com",
    csrf_token_url: 'https://bizdatapi-sb2.bizdata360.com/api',
    ENCRYPTION_SECRET_KEY : "jL1_5BWXmUYgTdAO0jjIQlGnx4UaVMS66xrN9UQbj-s=",
    integration_secretkey : 'Z2jRXES783aKgA3rUvtTMVynRkC3WcXddxTXF2sSwhg=',
};
